import Vue from 'vue';
import Router from 'vue-router';
import LayoutDefault from './layouts/LayoutDefault';
import LayoutAuth from './layouts/LayoutAuth';
import LayoutAnalytics from './layouts/LayoutAnalytics';
import ViewAnalyticsBudget from './views/ViewAnalytics/ViewAnalyticsBudget';
import ViewAnalyticsClients from './views/ViewAnalytics/ViewAnalyticsClients';
import ViewAnalyticsClientCondition from './views/ViewAnalytics/ViewAnalyticsClientCondition';
import ViewAnalyticsManagers from './views/ViewAnalytics/ViewAnalyticsManagers';
import ViewAnalyticsDirections from './views/ViewAnalytics/ViewAnalyticsDirections';
import ViewAnalyticsSupplierCondition from './views/ViewAnalytics/ViewAnalyticsSupplierCondition';
import ViewAnalyticsTop from './views/ViewAnalytics/ViewAnalyticsTop';
import ViewAnalyticsSummary from "./views/ViewAnalytics/ViewAnalyticsSummary";
import ViewAuthCheckPhone from './views/ViewAuth/ViewAuthCheckPhone';
import ViewAuthRegistration from './views/ViewAuth/ViewAuthRegistration';
import ViewImport from './views/ViewImport/ViewImport';
import ViewSettings from './views/ViewSettings/ViewSettings';
import ViewSettingsAliases from './views/ViewSettings/ViewSettingsAliases';
import ViewSettingsLogs from './views/ViewSettings/ViewSettingsLogs';
import ViewSettingsUserClients from './views/ViewSettings/ViewSettingsUserClients';
import ViewSettingsClients from './views/ViewSettings/ViewSettingsClients';
import ViewSettingsBrands from './views/ViewSettings/ViewSettingsBrands';
import ViewSettingsSlice from "./views/ViewSettings/ViewSettingsSlice";
import ViewSettingsGroupHead from './views/ViewSettings/ViewSettingsGroupHead';
import ViewSettingsRagicBudget from './views/ViewSettings/ViewSettingsRagicBudget';
import serviceAuth from './services/serviceAuth';
import ViewSettingsHistory from "./views/ViewSettings/ViewSettingsHistory";
import ViewSettingsTelegram from "./views/ViewSettings/ViewSettingsTelegram.vue";
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'default',
            component: LayoutDefault,
            meta: {
                auth: true
            },
            children: [
                {
                    path: 'analytics',
                    name: 'analytics',
                    component: LayoutAnalytics,
                    meta: {
                        auth: true
                    },
                    children: [
                        {
                            path: 'budget',
                            name: 'analyticsBudget',
                            component: ViewAnalyticsBudget,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'clients',
                            name: 'analyticsClients',
                            component: ViewAnalyticsClients,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'client-condition',
                            name: 'analyticsClientCondition',
                            component: ViewAnalyticsClientCondition,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'managers',
                            name: 'analyticsManagers',
                            component: ViewAnalyticsManagers,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'directions',
                            name: 'analyticsDirections',
                            component: ViewAnalyticsDirections,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'supplyers',
                            name: 'analyticsSupplyers',
                            component: ViewAnalyticsSupplierCondition,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'top',
                            name: 'analyticsTop',
                            component: ViewAnalyticsTop,
                            meta: {
                                auth: true
                            },
                        },
                        {
                            path: 'summary',
                            name: 'analyticsSummary',
                            component: ViewAnalyticsSummary,
                            meta: {
                                auth: true
                            },
                        }
                    ]
                },
                {
                    path: 'import',
                    name: 'import',
                    component: ViewImport,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: 'settings',
                    name: 'settings',
                    component: ViewSettings,
                    meta: {
                        auth: true
                    }
                },
                {
                    path: 'settings/aliases',
                    name: 'settingsAliases',
                    component: ViewSettingsAliases,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/logs',
                    name: 'settingsLogs',
                    component: ViewSettingsLogs,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/user-clients',
                    name: 'settingsUserClients',
                    component: ViewSettingsUserClients,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/group-head',
                    name: 'settingsGroupHead',
                    component: ViewSettingsGroupHead,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/clients',
                    name: 'settingsClients',
                    component: ViewSettingsClients,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/history',
                    name: 'settingsHistory',
                    component: ViewSettingsHistory,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/brands',
                    name: 'settingsBrands',
                    component: ViewSettingsBrands,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/slices',
                    name: 'settingsSlice',
                    component: ViewSettingsSlice,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/ragic-budget',
                    name: 'settingsRagicBudget',
                    component: ViewSettingsRagicBudget,
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'settings/chameleon-notify',
                    name: 'settingsTelegramNotify',
                    component: ViewSettingsTelegram,
                    meta: {
                        auth: true,
                    },
                }
            ]
        },
        {
            path: '/auth',
            name: 'auth',
            component: LayoutAuth,
            children: [
                // {
                //     path: 'login',
                //     name: 'login',
                //     component: ViewAuthLogin
                // },
                {
                    path: 'check-phone',
                    name: 'check-phone',
                    component: ViewAuthCheckPhone
                },
                {
                    path: 'registration',
                    name: 'registration',
                    component: ViewAuthRegistration
                }
            ]
        },
        // {
        //     path: '/login',
        //     redirect: '/auth/login'
        // },
        {
            path: '/check-phone',
            redirect: '/auth/check-phone'
        },
        {
            path: '/registration',
            redirect: '/auth/registration'
        },
        { path: '*', redirect: '/' },
    ]
});

// управление маршрутами в зависимости от того, залогинен ли юзер
router.beforeEach((to, from, next) => {
    // if (to.name === 'login' || to.name === 'check-phone' || to.name === 'registration') {
    if (to.name === 'check-phone' || to.name === 'registration') {
        if (serviceAuth.isLogin())
            next({name: 'default'});
        else
            next();
    }
    if (to.name === 'auth') {
        if (serviceAuth.isLogin())
            next({name: 'default'});
        else
            next({name: 'check-phone'});
            // next({name: 'login'});
    }
    if (to.meta.auth === true) {
        if (!serviceAuth.isLogin())
            next({name: 'check-phone'});
        else {
            if (to.name === 'default' || to.name === 'analytics')
                next({name: 'analyticsSummary'});
            else
                next();
        }
    }
});

export default router;
